import { PayloadAction } from '@reduxjs/toolkit';

import { ExtraReducerBuilder } from '../../types/shared';
import { WritableQuoteBuilderStateType } from '../../types/state';
import { deleteSnapQuoteAttachment } from '../endpoints/delete-snap-quote-attachment';
import { withSaveStateUpdate } from '../utilities/with-save-state-update';

function deleteSnapQuoteAttachmentFulfilled(
  state: WritableQuoteBuilderStateType,
  action: PayloadAction<typeof deleteSnapQuoteAttachment.Types.ResultType>,
) {
  state.documentIds = state.documentIds.filter(
    (id) => id !== action.payload.id,
  );
  delete state.documents[action.payload.id];
}

export function deleteSnapQuoteAttachmentReducer(builder: ExtraReducerBuilder) {
  builder.addMatcher(
    deleteSnapQuoteAttachment.matchFulfilled,
    withSaveStateUpdate(deleteSnapQuoteAttachmentFulfilled),
  );
}
